<template>
  <div :style="'padding-top:20px;'">
    <div class="win" :style="';background-size:100%;background-color:'+data.style.backgroundColor">
      <div class="head s_cfff text-ac p-t-20 m-b-10">
        <p class="fz-26 s_font_b" :style="'color:'+data.style.titleColor">恭喜中奖</p>
      </div>
      <div class="main m-b-22">
        <div class="item" :style="'color:'+data.style.des_color" >
          <img src="@/assets/images/scan/reb.png" alt="">
          <div>
            <p class="fz-17 s_c131212 s_font_b m-b-5">1元红包</p>
            <p class="s_c737373 fz-14">{{data.params.rebTips}}</p>
          </div>
        </div>
        <div class="item" :style="'color:'+data.style.des_color" >
          <img src="@/assets/images/scan/jf.png" alt="">
          <div>
            <p class="fz-17 s_c131212 s_font_b m-b-5">1积分</p>
            <p class="s_c737373 fz-14">{{data.params.jifenTips}}</p>
          </div>
        </div>
      </div>
      <div class="btn" :style="'background-size:100%;background-color:'+data.style.buttonColor+';color:'+data.style.buttonTextColor">
        继续扫码
      </div>
    </div>
  </div>
</template>
<script>
import config from "@/config";
export default {
  name: "success",
  props: { data: Object },
  setup() {
    const oss = config.oss[process.env.VUE_APP_type];
    return {
      oss,
    };
  },
};
</script>

<style lang="less" scoped>
.win {
  width: 300px;
  margin: 0 auto;
  padding-bottom: 22px;
  background-repeat: no-repeat;
  background-size: 100%;
  background-position: center;
  position: relative;
  border-radius: 10px;
  // .head{
  //   color: #fff;
  //   text-align: center;
  // }
  .main {
    .item {
      width: 95%;
      margin: 5px auto;
      display: flex;
      padding:  22px 15px;
      line-height: 1;
      position: relative;
      font-size: 12px;
      font-weight: 500;
      align-items: center;
      position: relative;
      // border-radius: 10px;
      background-image: url('../../../../../../../assets/images/scan/item.png');
      background-size: cover;
      background-repeat: no-repeat;
      img {
        width: 41px;
        height: 41px;
        margin-right: 20px;
      }
      .get {
        background: #FF0E41;
        border-radius: 22px;
        color: #fff;
        padding: 15px;
        position: absolute;
        right: 20px;
        top: 50%;
        transform: translateY(-50%);
      }
    }
  }
  .btn{
    margin: 0 auto ;
    background-color: #FFAE59;
    color: #fff;
    width: 150px;
    border-radius: 20px;
    height: 44px;
    text-align: center;
    line-height: 44px;
  }
}
</style>